
export class VideoAdapter {

  static VIDEO_JS = "VIDEO_JS";
  static YOUTUBE = "YOUTUBE";

  static YT_SEEK_INTERVAL_MS = 30;

  YT_ENDED = 0;
  YT_PLAYING = 1;
  YT_PAUSED = 2;


  player;
  player_type;

  onPlayCallback = () => {};
  onPauseCallback = () => {};
  onEndedCallback = () => {};
  onSeekedCallback = () => {};

  youtube_seeked_interval;
  current_time_cached;

  constructor(player, player_type){
    this.player = player;
    this.player_type = player_type;
  }

  tearDown(){
    if(this.isYoutube()) this.stopOnSeekedMonitoring();
  }

  isVideoJS(){
    return this.player_type == VideoAdapter.VIDEO_JS;
  }

  isYoutube(){
    return this.player_type == VideoAdapter.YOUTUBE;
  }

  pause(){
    if(this.isVideoJS()) this.player.pause();
    if(this.isYoutube()) this.player.pauseVideo();
  }

  isPaused(){
    if(this.isVideoJS()) return this.player.paused();
    if(this.isYoutube()) {
      // https://developers.google.com/youtube/iframe_api_reference#Functions
      let state = this.player.getPlayerState();
      return state != this.YT_PLAYING;
    }
  }

  isMuted(){
    if(this.isVideoJS()) return this.player.muted();
    if(this.isYoutube()) return this.player.isMuted();
  }

  setMute(mute){
    if(this.isVideoJS()) this.player.mute(mute);
    if(this.isYoutube()) {
      if(mute) this.player.mute();
      else this.player.unMute();
    }
  }

  getDuration(){
    if(this.isVideoJS()) return this.player.duration();
    if(this.isYoutube()) return this.player.getDuration()
  }

  play(){
    if(this.isVideoJS()) this.player.play();
    if(this.isYoutube()) this.player.playVideo();
  }

  getPlaybackRate(){
    if(this.isVideoJS()) return this.player.playbackRate();
    if(this.isYoutube()) return this.player.getPlaybackRate();
  }

  setPlaybackRate(playbackRate){
    if(this.isVideoJS()) this.player.playbackRate(playbackRate);

    // for youtube, wont work with 300%
    // actually, we should listen for the confirmation:
    // https://developers.google.com/youtube/iframe_api_reference#Events
    if(this.isYoutube()) this.player.setPlaybackRate(playbackRate);
  }

  src(src){
    if(this.isVideoJS()) this.player.src(src);
    if(this.isYoutube()) this.player.loadVideoById(src);
  }

  setStream(stream){
    if(this.isVideoJS()) this.player.tech().el().srcObject = stream;
  }

  getCurrentTime(){
    if(this.isVideoJS()) return this.player.currentTime();

    if(this.isYoutube()){
      // Caution: this might interfere with moving the cursor limits with half counts
      // when the half counts are below 0.2 time
      // Relief: during first test this was not the case but might be for faster songs?
      // Real Relief: when updating with cursor, then we set the new time and dont get it
      // BUT: monitor this potential issue...

      // when the player is slower than normal, the getCurrentTime reports old values
      let currentTime = this.player.getCurrentTime();
      let diff = currentTime - this.current_time_cached;
      if(diff < 0 && diff > - 0.2){
        // console.log("currentTime diff:", diff);
        currentTime = this.current_time_cached;        
      } else {
        this.current_time_cached = currentTime;
      }
      return currentTime;
    }
  }

  setCurrentTime(new_time){
    if(this.isVideoJS()) this.player.currentTime(new_time);
    if(this.isYoutube()) this.player.seekTo(new_time);
  }



  oncanplaythrough(callback){
    if(this.isVideoJS()) this.player.on("canplaythrough", callback);
  }

  onplay(callback){
    if(this.isVideoJS()) this.player.on("play", callback);
    if(this.isYoutube()) this.onPlayCallback = callback;
  }

  onpause(callback){
    if(this.isVideoJS()) this.player.on("pause", callback);
    if(this.isYoutube()) this.onPauseCallback = callback;
  }

  ontimeupdate(callback){
    if(this.isVideoJS()) this.player.on("timeupdate", callback);
  }

  onseeked(callback){
    if(this.isVideoJS()) this.player.on("seeked", callback);
    if(this.isYoutube()) {
      this.onSeekedCallback = callback;
      this.startOnSeekedMonitoring();
    }
  }

  onended(callback){
    if(this.isVideoJS()) this.player.on("ended", callback);
    if(this.isYoutube()) this.onEndedCallback = callback;
  }


  // youtube only
  onStateChange(event){
    // console.log("youtube adapter: ", event);
    if(event.data == this.YT_ENDED) this.onEndedCallback();
    if(event.data == this.YT_PLAYING) this.onPlayCallback();
    if(event.data == this.YT_PAUSED) this.onPauseCallback();
  }

  startOnSeekedMonitoring(){
    var lastTime = this.player.getCurrentTime();
    var intervalInMS = VideoAdapter.YT_SEEK_INTERVAL_MS;
    var intervalInS = intervalInMS / 1000;

    this.youtube_seeked_interval = setInterval(() => {
      // console.log("youtube_seeked_interval");
      var t = this.player.getCurrentTime();

      // seek in playing mode also always triggers a seek in paused mode because the video pauses real quick
      // but the real playing seek is triggered faster and prohibits the seek_range knob to flatter
      if(this.player.getPlayerState() == this.YT_PLAYING ) {
        if (Math.abs(t - lastTime - intervalInS) > (intervalInS*0.5)) {
          // console.log("seek in playing mode");
        }
      }

      if(this.player.getPlayerState() == this.YT_PAUSED ) {
        if (Math.abs(t - lastTime) > (intervalInS*0.5)) {
          // console.log("seek in paused mode");
          this.onSeekedCallback()
        }
      }

      lastTime = this.player.getCurrentTime();
    }, intervalInMS);
  }

  stopOnSeekedMonitoring(){
    if(this.youtube_seeked_interval) clearInterval(this.youtube_seeked_interval);
  }

}



// WEBPACK FOOTER //
// ./src/models/video.adapter.ts